import SetNewPassword from 'pages/ResetPassword/SetNewPassword'
import NavigationMobile from 'components/NavigationMobile'
import GoogleCallback from 'pages/GoogleCallback'
import ProtectedRoute from 'utils/protectedRoute'
import { Route, Routes } from 'react-router-dom'
import SavedProfiles from 'pages/SavedProfiles'
import ManageProfile from 'pages/ManageProfile'
import AppleCallback from 'pages/AppleCallback'
import { useAuth } from 'contexts/AuthContext'
import RestPassword from 'pages/ResetPassword'
import { useEffect, useState } from 'react'
import Unpublished from 'pages/Unpublished'
import AddObituary from 'pages/AddObituary'
import MyProfiles from 'pages/MyProfiles'
import Profilepin from 'pages/Profilepin'
import AddProfile from 'pages/AddProfile'
import Dashboard from 'pages/Dashboard'
import { isIOS } from 'utils/nativeApp'
import QrScanner from 'pages/QrScanner'
import Explainer from 'pages/Explainer'
import Loader from 'components/Loader'
import QrReader from 'pages/QrReader'
import Notfound from 'pages/Notfound'
import Settings from 'pages/Settings'
import Profile from 'pages/Profile'
import Signin from 'pages/Signin'
import Order from 'pages/Order'
import Login from 'pages/Login'
import Help from 'pages/Help'
import Map from 'pages/Map'
import './App.scss'

// const LAST_PAGE_KEY = 'end'
const ios = isIOS()

function App() {
  const [isLoading, setLoading] = useState(true)

  const { isAuth, isGuest, refreshToken } = useAuth()

  // useEffect(() => {
  //   const { href, origin } = window.location
  //   const homePath = `${origin}/`

  //   if (((performance.getEntriesByType('navigation')[0]) as any).type !== 'reload') {
  //     window.history.replaceState(LAST_PAGE_KEY, '', homePath)
  //     window.history.pushState(null, '', homePath)
  //     window.history.pushState(null, '', href)
  //   }
  // }, [])

  // useEffect(() => {
  //   const popstate = () => {
  //     const { state } = window.history
  //     console.log(window.location)
  //     if (state === LAST_PAGE_KEY) window.history.go(1)
  //   }

  //   // const orientationchange = () => {
  //   //   if (ios) window.scrollTo(0, 0)
  //   // }

  //   window.addEventListener('popstate', popstate)
  //   // window.addEventListener('orientationchange', orientationchange)

  //   return () => {
  //     window.removeEventListener('popstate', popstate)
  //     // window.removeEventListener('orientationchange', orientationchange)
  //   }
  // }, [])

  useEffect(() => {
    const updateVH = () => {
      const vh = window.innerHeight * 0.01
      document.body.style.setProperty('--vh', `${vh}px`)
    }
    updateVH()
    window.addEventListener('resize', updateVH)
    return () => {
      window.removeEventListener('resize', updateVH)
    }
  }, [])

  useEffect(() => {
    if (!window.location.pathname.includes('auth')) {
      refreshToken().then(() => {
        setLoading(false)
      })
    } else {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <main className={`app${ios ? ' --ios' : ''}`}>
      {isLoading
        ? <Loader type='full' />
        : <>
          <NavigationMobile />
          <Routes>
            <Route path='/' element={(isAuth || isGuest) ? <Dashboard /> : <Login />} />
            <Route path='/login' element={<Login />} />
            <Route path='/signin' element={<Signin />} />
            <Route path='/profile/*' element={<Profile />} />
            <Route path='/qr/*' element={<QrReader />} />
            <Route path='/qrscanner' element={<QrScanner />} />
            <Route path='/explainer/*' element={<Explainer />} />
            <Route path='/resetpassword' element={<RestPassword />} />
            <Route path='/unpublished/*' element={<Unpublished />} />
            <Route path='/notfound' element={<Notfound />} />
            <Route path='/order' element={<Order />} />
            <Route path='/password/reset' element={<SetNewPassword />} />
            {/* <Route path='/explainer/*' element={<ProtectedRoute setModal={setLoginRequired}><Explainer /></ProtectedRoute>} /> */}
            <Route path='/addprofile/*' element={<ProtectedRoute>
              <Routes>
                <Route index element={<AddProfile />} />
                <Route path=':id' element={<AddProfile />} />
                <Route path=':id/:action' element={<AddProfile />} />
              </Routes>
            </ProtectedRoute>}
            />
            <Route path='/addobituary/*' element={<ProtectedRoute><AddObituary /></ProtectedRoute>} />
            <Route path='/map' element={<ProtectedRoute><Map /></ProtectedRoute>} />
            <Route path='/payment/complete' element={<Login orderId='xxx' />} />
            <Route path='/myprofiles' element={<ProtectedRoute><MyProfiles /></ProtectedRoute>} />
            <Route path='/profilepin/*' element={<ProtectedRoute><Profilepin /></ProtectedRoute>} />
            <Route path='/manage/*' element={<ProtectedRoute><ManageProfile /></ProtectedRoute>} />
            <Route path='/savedprofiles' element={<ProtectedRoute><SavedProfiles /></ProtectedRoute>} />
            <Route path='/help' element={<Help />} />
            <Route path='/settings' element={<ProtectedRoute requirement='user'><Settings /></ProtectedRoute>} />

            <Route path="/auth/google" element={<GoogleCallback />}></Route>
            <Route path="/auth/apple" element={<AppleCallback />}></Route>
            {/* <Route path="/auth/facebook" element={<FacebookCallback />}></Route> */}
          </Routes>
        </>}
    </main>
  )
}

export default App
